import React from "react";

/**
 * Batch A · R5 — LTR-isolated wrapper for form / file / voucher / FSLI
 * refs so English codes don't visually reverse inside Arabic text
 * (e.g. "314(a)" not "(a)314", "1201-03" not "03-1201").
 *
 * Rules:
 *   - Wrap NUMBERS and CODES only (form refs, file refs, FSLI codes,
 *     voucher UINs, counts). Do NOT wrap Arabic titles/labels.
 *   - Uses <bdi dir="ltr"> + `unicode-bidi: isolate` so the wrapped
 *     token participates in the RTL flow as one opaque LTR unit.
 *
 * Usage:
 *   <Ref>314(a)</Ref>
 *   <Ref>{form.ref_no}</Ref>
 *   <Ref>{`${fs_code}-${file_id}`}</Ref>
 */
export default function Ref({ children, className, ...rest }) {
  return (
    <bdi dir="ltr" style={{ unicodeBidi: "isolate" }}
          className={className} {...rest}>
      {children}
    </bdi>
  );
}
